import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ciscoThousandEyes = defineConnector({
  identifier: "ciscoThousandEyes",
  name: "Cisco ThousandEyes",
  tagLine: "Network intelligence and monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.thousandeyes\\.com/.*",
  auth: (app) => bearerAuth(app.secret.bearerToken),
  steps: [
    {
      title: "Generate an OAuth bearer token",
      items: [
        {
          kind: "markdown",
          content:
            "In your ThousandEyes portal, go to **Account Settings > Users and Roles > Profile**. Under the **User API Tokens** section, create an OAuth bearer token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Bearer token",
          required: true,
          target: { kind: "secrets", field: "bearerToken" },
          helperText: "The OAuth bearer token from your ThousandEyes profile.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.thousandeyes.com/v7/status",
  },
});
